"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.q = exports.w = exports.helpers = exports.ctrls = exports.com = void 0;
__exportStar(require("./core"), exports);
__exportStar(require("./helpers/index"), exports);
__exportStar(require("./com"), exports);
__exportStar(require("./ctrls"), exports);
const core_1 = require("./core");
const gsLib = require("./index");
const comLib = require("./com");
const ctrlsLib = require("./ctrls");
const helpersLib = require("./helpers/index");
exports.com = comLib;
exports.ctrls = ctrlsLib;
exports.helpers = helpersLib;
/**
* Wrap element in WrapperGs
* @param el
*/
function w(el) { return core_1.WrapperGS.Wrap(el); }
exports.w = w;
function q(selector) { return core_1.GS.Query(selector); }
exports.q = q;
globalThis.gs = gsLib;
core_1.WrapperGS.ExtendComponentsByTagClass(gsLib.BoxItem);
core_1.WrapperGS.ExtendComponentsByTagClass(gsLib.CheckBox);
core_1.WrapperGS.ExtendComponentsByTagClass(gsLib.BtnsBox);
core_1.WrapperGS.ExtendComponentsByTagClass(gsLib.RadioBox);
core_1.WrapperGS.ExtendComponentsByTagClass(gsLib.ToggleGS);
core_1.WrapperGS.ExtendComponentsByTagClass(gsLib.FormGS);
core_1.WrapperGS.ExtendComponentsByHTMLElement(gsLib.FormGS);
core_1.WrapperGS.ExtendComponentsByHTMLElement(gsLib.ImageGS);
core_1.WrapperGS.ExtendComponentsByHTMLElement(gsLib.InputFilesGS);
core_1.WrapperGS.ExtendComponentsByHTMLElement(gsLib.InputGS);
core_1.WrapperGS.ExtendComponentsByHTMLElement(gsLib.TextAreaGS);
//# sourceMappingURL=index.js.map